import { SyncDescriptor } from './descriptors';
/**
 * 静态模块收集器，用于将模块收集起来，初始化DI框架时使用
 */
export class ServiceRegister {
    constructor() {
        this.innerRegistry = [];
        this.innerMultiRegistry = [];
    }
    register(id, ctor, staticArguments, supportsDelayedInstantiation) {
        // 将模块放入数组
        this.innerRegistry.push([
            id,
            new SyncDescriptor(ctor, staticArguments, supportsDelayedInstantiation),
        ]);
    }
    registerValue(id, value) {
        this.innerRegistry.push([id, value]);
    }
    registerMulti(id, ctor, staticArguments, supportsDelayedInstantiation) {
        // 将模块放入数组
        this.innerMultiRegistry.push([
            id,
            new SyncDescriptor(ctor, staticArguments, supportsDelayedInstantiation),
        ]);
    }
    registerMultiValue(id, value) {
        this.innerMultiRegistry.push([id, value]);
    }
    /**
     * 获取已经收集的模块
     */
    getServiceDescriptors() {
        return this.innerRegistry;
    }
    getMulServiceDescriptor() {
        return this.innerMultiRegistry;
    }
}
//# sourceMappingURL=service-register.js.map